import axios from "axios";
import { baseURL, operatorType } from "../config";
import jwt from "./jwt";

const getNewToken = async () => {
  const refreshToken = localStorage.getItem("refreshToken");
  const headers = {};
  headers.refreshtoken = `Bearer ${refreshToken}`;

  const response = await axios({
    method: "get",
    url: `${baseURL}/user/updateToken`,
    headers,
  });
  const { data, statusCode } = response.data;
  if (statusCode === "error") {
    return true;
  } else {
    localStorage.setItem("idToken", data);
    let newToken = data;
    return newToken;
  }
};

export const Fetch = async (path, options = {}, authorization = false) => {
  try {
    const token = localStorage.getItem("idToken");
    const decodedToken = jwt.decode(token);
    let userType;
    if (authorization && !token) {
      throw new Error("No JWT token found");
    }
    const headers = {
      ...options.headers,
    };
    if (token) {
      headers.authorization = `Bearer ${token}`;
    }
    let url = `${baseURL}${path}`;
    if (decodedToken && decodedToken.userType) {
      userType = decodedToken.userType;
    }
    if (decodedToken && decodedToken.isElectricUser) {
      userType = "ELECTRIC";
    }
    if (sessionStorage.getItem("userType")) {
      userType = sessionStorage.getItem("userType");
    }
    if (decodedToken && decodedToken.id) {
      headers.userId = decodedToken.id;
    }

    if (userType === operatorType.BUSOWNER) {
      url = `${baseURL}/mg${path}`;
    }

    if (
      (userType === operatorType.CABOWNER ||
        userType === operatorType.BUSOWNER) &&
      decodedToken &&
      decodedToken.mgId
    ) {
      headers.userId = decodedToken.mgId;
    }
    if (userType === "ELECTRIC" && decodedToken && decodedToken.electricId) {
      url = `${baseURL}/electric${path}`;
      headers.userId = decodedToken.electricId;
    }

    if (sessionStorage.getItem("tempUserId")) {
      headers.userId = sessionStorage.getItem("tempUserId");
    }

    const response = await axios({
      method: "get",
      url: `${url}`,
      ...options,
      headers,
    });
    const { data, statusCode } = response.data;
    if (statusCode === "error" && data === "failed with 401") {
      //update token
      let newToken = await getNewToken();
      const decodedToken = jwt.decode(newToken);

      headers.userId = decodedToken.id;
      if (newToken == true) {
        localStorage.removeItem("idToken");
        this.props.history.replace("/login");
      }

      //retry request
      headers.authorization = `Bearer ${newToken}`;

      if (decodedToken && decodedToken.id) {
        headers.userId = decodedToken.id;
      }
      if (
        decodedToken &&
        decodedToken.mgId &&
        userType === operatorType.BUSOWNER
      ) {
        headers.userId = decodedToken.mgId;
      }
      if (decodedToken && userType === operatorType.BUSOWNER) {
        url = `${baseURL}/mg${path}`;
      }
      if (userType === "ELECTRIC" && decodedToken && decodedToken.electricId) {
        url = `${baseURL}/electric${path}`;
        headers.userId = decodedToken.electricId;
      }

      if (sessionStorage.getItem("tempUserId")) {
        headers.userId = sessionStorage.getItem("tempUserId");
      }

      const newResponse = await axios({
        method: "get",
        url: `${url}`,
        ...options,
        headers,
      });
      const { data, statusCode } = newResponse.data;
      if (statusCode === "ok") {
        return data;
      }
    } else {
      if (data && data.refreshToken && data.accessToken) {
        localStorage.setItem("idToken", data.accessToken);
        localStorage.setItem("refreshToken", data.refreshToken);
      }
      return data;
    }
  } catch (err) {
    console.log(err);
  }
};

export const downloadPDF = async (
  path,
  options = {},
  authorization = false,
) => {
  try {
    const token = localStorage.getItem("idToken");
    const decodedToken = jwt.decode(token);
    let userType = decodedToken.userType;
    if (decodedToken && decodedToken.isElectricUser) {
      userType = "ELECTRIC";
    }
    if (sessionStorage.getItem("userType")) {
      userType = sessionStorage.getItem("userType");
    }
    if (authorization && !token) {
      throw new Error("No JWT token found");
    }
    const headers = {
      ...options.headers,
    };

    if (token) {
      headers.authorization = `Bearer ${token}`;
    }
    let url = `${baseURL}${path}`;
    if (decodedToken && decodedToken.id) {
      headers.userId = decodedToken.id;
    }
    if (
      decodedToken &&
      decodedToken.isMGUser &&
      decodedToken.mgId &&
      userType === operatorType.BUSOWNER
    ) {
      headers.userId = decodedToken.mgId;
      url = `${baseURL}/mg${path}`;
    }
    if (userType === "ELECTRIC" && decodedToken && decodedToken.electricId) {
      url = `${baseURL}/electric${path}`;
      headers.userId = decodedToken.electricId;
    }
    if (sessionStorage.getItem("tempUserId")) {
      headers.userId = sessionStorage.getItem("tempUserId");
    }
    const response = await axios({
      method: "get",
      responseType: "arraybuffer",
      url: `${url}`,
      ...options,
      headers,
    });

    let decoded;
    try {
      decoded = new TextDecoder("utf-8").decode(response.data);

      const parsed = JSON.parse(decoded);

      if (parsed.statusCode === "error" && parsed.data === "failed with 401") {
        let newToken = await getNewToken();
        const decodedToken = jwt.decode(newToken);
        headers.userId = decodedToken.id;
        if (sessionStorage.getItem("tempUserId")) {
          headers.userId = sessionStorage.getItem("tempUserId");
        }
        if (newToken == true) {
          localStorage.removeItem("idToken");
          this.props.history.replace("/login");
        }
        headers.authorization = `Bearer ${newToken}`;

        const retryResp = await axios({
          method: "get",
          responseType: "arraybuffer",
          url: `${url}`,
          ...options,
          headers,
        });
        return retryResp.data;
      } else {
        return response.data;
      }
    } catch (err) {
      // If parsing fails, it's likely a PDF binary, so we can return it directly

      return response.data;
    }
  } catch (err) {
    console.log(err);
  }
};
